<template>
  <div class="flex gap-2">
    <input
      :id="id.toString()"
      v-model="selected"
      :value="value"
      class="checkbox-input border-gray-500 size-5 border text-black focus:ring-2"
      :class="{ 'group-hover:bg-gray-200': !selected }"
      type="checkbox"
      @change="emit('change')"
    />
    <label
      :for="id.toString()"
      class="group flex cursor-pointer space-x-2 text-sm"
      :class="{ 'font-bold': selected, 'items-center': centered }"
    >
      <span>
        <slot name="label">{{ label }}</slot>
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
type CheckboxProps = {
  value?: string | number
  centered?: boolean
  checked?: boolean
  id: string | number
  label?: string
}

const props = withDefaults(defineProps<CheckboxProps>(), {
  value: '',
  centered: true,
  checked: false,
  label: undefined,
})

const emit = defineEmits<{
  change: []
  input: [value: boolean]
}>()

const selected = computed({
  get: () => props.checked,
  set: (newValue: boolean) => emit('input', newValue),
})
</script>

<style scoped>
/* This is a exception because the checkbox is taking in the line height of the text */
.checkbox-input {
  min-height: auto !important;
  padding: 0 !important;
  line-height: 1 !important;
}
</style>
